import { createRootRoute, Link, Outlet } from "@tanstack/react-router";

/**
 * Portal SPA root route.
 *
 * Distinct from the staff `__root.tsx`: no Sonner toaster (portal
 * uses inline ErrorState components for failures, not floating
 * notifications — quieter UX appropriate for an external customer
 * surface).
 *
 * `notFoundComponent` per docs/design-canon/01-ui/navigation.md R7:
 * any unmatched route renders a friendly page with a link back,
 * rather than a blank screen or raw "Not Found" string.
 */
export const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return <Outlet />;
}

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-3xl font-bold text-fg">Page not found</h1>
      <p className="max-w-md text-sm text-fg-subtle">
        The page you&rsquo;re looking for doesn&rsquo;t exist or has moved.
      </p>
      <Link
        to="/portal"
        className="rounded-md bg-brand px-4 py-2 text-sm font-medium text-brand-fg hover:bg-brand-deep"
      >
        Back to the portal
      </Link>
    </div>
  );
}
